module.exports = "https://static.wanderu.com/static/media/thenewyorker-x2.977277ae.png";